import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from '../../../../core/util/core/Fetch';
import { chooseProfileFilter } from '../../../helpers/chooseProfileFilter';
import sleep from 'sleep-promise';

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const profileFilter = chooseProfileFilter();
    const navigate = useNavigate();

    const path = '/people/';
    const paths = {
        endpointSave: config.endpoints.backend + 'people/save',
        endpointGetById: config.endpoints.backend + 'people/getAllInfoById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllPeopleTypes:
            config.endpoints.backend + 'peopletypes/getall',
        endpointGetAllBanks: config.endpoints.backend + 'banks/getall',
        endpointGetAllSuppliers: config.endpoints.backend + 'people/getSuppliers',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    };

    const hiddenValues = {};

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id;
    }

    const labels = {
        labelTitleAdd: 'Nova Pessoa',
        labelTitleEdit: 'Editar Pessoa',
        labelTitleView: 'Visualizar Pessoa'
    };

    const getForm = (values) => {
        let person_type = values.people_type;
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_company_id
                    ? {
                          name: 'pdc_company_id',
                          type: 'select',
                          label: 'Empresa',
                          options: [],
                          optionsEndpoint: {
                              endpoint: paths.endpointGetAllCompanies,
                              label: 'corporate_name',
                              value: 'id',
                              params: {
                                  filter: {
                                      ...profileFilter
                                  }
                              }
                          },
                          validations: {
                              required: true
                          },
                          columnSize: 12
                      }
                    : {},
                {
                    name: 'people_type',
                    type: 'select',
                    options: [
                        { label: 'Física', value: 'F' },
                        { label: 'Jurídica', value: 'J' },
                        { label: 'Terceiro Setor', value: 'T' }
                    ],
                    label: 'Tipo de pessoa',
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />
                        );
                    }
                },
                ...(person_type === 'F'
                    ? [
                          {
                              name: 'name',
                              type: 'text',
                              label: 'Nome',
                              validations: {
                                  required: true
                              },
                              columnSize: 12
                          }
                      ]
                    : [
                          {
                              name: 'corporate_name',
                              type: 'text',
                              label: 'Razão Social',
                              columnSize: 12,
                              validations: {
                                  required: person_type !== 'J'
                              }
                          },
                          {
                              name: 'fantasy_name',
                              type: 'text',
                              label: 'Nome Fantasia',
                              columnSize: 12,
                              validations: {
                                  required: false
                              }
                          }
                      ]),
                {
                    label: 'Tipo de Endereço',
                    name: 'type_address',
                    type: 'select',
                    options: [
                        {
                            label: 'Comercial',
                            value: 'COMERCIAL'
                        },
                        {
                            label: 'Residencial',
                            value: 'RESIDENCIAL'
                        },
                        {
                            label: 'Cobrança',
                            value: 'COBRANÇA'
                        },
                        {
                            label: 'Entrega',
                            value: 'ENTREGA'
                        }
                    ],
                    validations: {
                        required: person_type !== 'T'
                    },
                    columnSize: 12
                },
                {
                    name: 'address',
                    type: 'address',
                    label: 'Endereço',
                    validations: {
                        required: person_type !== 'T'
                    },
                    columnSize: 12
                },
                ...(person_type === 'F'
                    ? [
                          {
                              name: 'rg',
                              type: 'RG',
                              label: 'RG',
                              columnSize: 6,
                              validations: {
                                  required: false
                              }
                          },
                          {
                              name: 'cpf',
                              type: 'CPF',
                              label: 'CPF',
                              validations: {
                                  required: true
                              },
                              columnSize: 6
                          }
                      ]
                    : [
                          {
                              name: 'estadual_registration',
                              type: 'text',
                              label: 'Inscrição Estadual',
                              validations: {
                                  required: false
                              },
                              columnSize: 6
                          },
                          {
                              name: 'cnpj',
                              type: 'CNPJ',
                              label: 'CNPJ',
                              validations: {
                                  required: person_type === 'J'
                              },
                              columnSize: 6
                          }
                      ]),
                {
                    label: 'Telefone',
                    type: 'phone',
                    name: 'phone',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                ...(person_type === 'F'
                    ? [
                          {
                              name: 'birth_date',
                              type: 'date',
                              label: 'Data de Nascimento',
                              columnSize: 6,
                              validations: {
                                  required: true
                              }
                          }
                      ]
                    : [
                          {
                              name: 'opening_date',
                              type: 'date',
                              label: 'Data de Abertura',
                              columnSize: 6,
                              validations: {
                                  required: person_type === 'J'
                              }
                          }
                      ]),

                {
                    name: 'contact',
                    type: 'text',
                    label: 'Pessoa de Contato',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                {
                    label: 'E-mail',
                    type: 'email',
                    name: 'email',
                    columnSize: 6,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'status',
                    type: 'select',
                    options: [
                        { label: 'Ativo', value: '1' },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Ativo',
                    columnSize: 12,
                    validations: {
                        required: true
                    }
                },
                {
                    name: 'pdc_people_type_id',
                    type: 'select',
                    label: 'Categoria de Pessoa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllPeopleTypes,
                        label: 'name',
                        value: 'id'
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'suppliers',
                    type: 'multiinput',
                    label: 'Lista de Fornecedores',
                    sortBy: 'index',
                    form: [
                        {
                            name: 'pdc_supplier_id',
                            type: 'select',
                            label: 'Fornecedor',
                            options: [],
                            optionsEndpoint: {
                                endpoint: paths.endpointGetAllSuppliers,
                                params: {
                                    filter: {
                                        ...profileFilter
                                    }
                                },
                                label: 'corporate_name',
                                value: 'id'
                            },
                            validations: {
                                required: false
                            }
                        }
                    ],
                    validations: {
                        required: false
                    },
                    columnSize: 12
                },
        
                {
                    name: 'pdc_bank_id',
                    type: 'select',
                    label: 'Banco',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllBanks,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: person_type !== 'T'
                    },
                    columnSize: 12
                },
                {
                    name: 'agency_number',
                    type: 'integer',
                    label: 'Número da Agência',
                    columnSize: 6,
                    validations: {
                        required: person_type !== 'T'
                    }
                },
                {
                    name: 'agency_digit',
                    type: 'text',
                    label: 'Dígito da Agência (Substitua X por 0)',
                    columnSize: 6,
                    mask: '9',
                    validations: {
                        required: person_type !== 'T'
                    }
                },
                {
                    name: 'account_number',
                    type: 'integer',
                    label: 'Número da Conta',
                    columnSize: 6,
                    validations: {
                        required: person_type !== 'T'
                    }
                },
                {
                    name: 'account_digit',
                    type: 'text',
                    label: 'Dígito da Conta (Substitua X por 0)',
                    columnSize: 6,
                    mask: '9',
                    validations: {
                        required: person_type !== 'T'
                    }
                },
                {
                    name: 'minified_code',
                    type: 'text',
                    label: 'Código Reduzido',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'cost_center',
                    type: 'text',
                    label: 'Centro de Custo',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'subsidiary_code',
                    type: 'text',
                    label: 'Código Matriz/Filial',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_iss',
                    type: 'text',
                    label: 'Código Reduzido ISS',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_inss',
                    type: 'text',
                    label: 'Código Reduzido INSS',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_csrf',
                    type: 'text',
                    label: 'Código Reduzido CSRF',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_irrf',
                    type: 'text',
                    label: 'Código Reduzido IRRF',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_discount',
                    type: 'text',
                    label: 'Código Reduzido Desconto',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                {
                    name: 'minified_code_fees',
                    type: 'text',
                    label: 'Código Reduzido Juros',
                    columnSize: 4,
                    validations: {
                        required: false
                    }
                },
                ...person_type == 'J'
                    ? [{
                          name: 'cnd_files',
                          type: 'multiUploadFileS3',
                          label: 'Certidão de Débitos',
                          uploadPath: 'people/cnd_files',
                          extensionAccept: '.jpeg,.jpg,.png,.pdf',
                          limitFileSize: 2,
                          imageCompress: true,
                          validations: {
                              required: false
                          },
                          columnSize: 12
                      },{
                            name: 'cnd_validity',
                            type: 'date',
                            label: 'Validade da Certidão de Débitos',
                            columnSize: 6,
                            validations: {
                                required: false
                            }
                      }]
                    : [{}]
            ],
            ...paths,
            ...labels
        };
        form.values = values;
        return form;
    };

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id });

                values = {
                    ...values,
                    pdc_people_type_id: "",
                };
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            );

            navigate('/people/add', { replace: true });
        };
        load();
    }, []);

    return <div>{formContent}</div>;
}
export default Form;
